import { AxiosInstance } from 'axios'
import { Test } from '../../models/test'
import { responseHandler } from './response'
import { Exam } from '../../models/exam'
import {Subscription, SubscriptionPlan} from '../../models/subscription'

export const getSubscriptions = async (client: AxiosInstance) =>
  responseHandler<SubscriptionPlan[]>(client.get('/subscriptions'))

export const getSubscription = async (client: AxiosInstance, subscriptionId: string) =>
  responseHandler<SubscriptionPlan>(client.get(`/subscriptions/${subscriptionId}`))

export const trialSubscription = async (client: AxiosInstance) =>
    responseHandler<SubscriptionPlan>(client.get(`/subscriptions/trialSubscription`))

export const getActiveSubscription = async (client: AxiosInstance) =>
    responseHandler<Subscription>(client.get(`/users/activeSubscription`))

export const cancelSubscription = async (client: AxiosInstance,password:string) =>
    responseHandler<void>(client.post(`/users/cancelSubscription`,{
        password
    }))